import { ReactNode } from 'react'
import { Button, Popup } from '@/ui'

interface BreakdownTooltipProps {
  trigger: ReactNode
  content: ReactNode
}

export const BreakdownTooltip = ({
  trigger,
  content,
}: BreakdownTooltipProps) => (
  <Popup
    trigger={<Button variant="discreet">{trigger}</Button>}
    content={content}
  />
)
